export default __webpack_public_path__ + "statics/fonts/Sixtyfour[wdth,wght].woff2";